import { render, staticRenderFns } from "./MediumCategoryCreateOrEdit.vue?vue&type=template&id=d455e46c&"
import script from "./MediumCategoryCreateOrEdit.vue?vue&type=script&lang=js&"
export * from "./MediumCategoryCreateOrEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports